import React from 'react';
import { motion } from 'framer-motion';
import { Home, Palette, Headphones } from 'lucide-react';
const resources = [{
  icon: Home,
  title: 'The Calm Down Corner',
  desc: 'Instrucciones paso a paso para crear un rincón de paz efectivo en tu casa.',
  color: 'text-calm',
  bg: 'bg-calm/10'
}, {
  icon: Palette,
  title: 'Color Palette Guide',
  desc: 'Una guía para padres sobre qué significan los colores que tu hijo elige al dibujar.',
  color: 'text-happiness',
  bg: 'bg-happiness/20'
}, {
  icon: Headphones,
  title: 'Audio Guide',
  desc: 'Enlace exclusivo para escuchar la pronunciación correcta de los términos emocionales.',
  color: 'text-fear',
  bg: 'bg-fear/10'
}];
export const ResourcesSection = () => {
  return <section className="w-full py-20 px-6 bg-cream" data-id="element-214">
      <div className="max-w-5xl mx-auto" data-id="element-215">
        <div className="text-center mb-12" data-id="element-216">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-dark mb-4" data-id="element-217">
            Recursos y Herramientas Extra
          </h2>
          <p className="font-body text-lg text-dark/70" data-id="element-218">
            Included bonuses to support your parenting journey
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-219">
          {resources.map((res, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-220">
              <div className={`w-12 h-12 rounded-xl ${res.bg} flex items-center justify-center mb-4`} data-id="element-221">
                <res.icon className={`w-6 h-6 ${res.color}`} data-id="element-222" />
              </div>
              <h3 className="font-display font-bold text-xl text-dark mb-2" data-id="element-223">
                {res.title}
              </h3>
              <p className="font-body text-dark/70 text-sm leading-relaxed" data-id="element-224">
                {res.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};